import { ReactElement } from 'react';
import { Redirect, Route, RouteProps } from 'react-router-dom';

import Storage from 'lib/Storage';

function ProtectedRoute({
  component: Component,
  ...rest
}: RouteProps): ReactElement<HTMLElement> {
  let storage = new Storage();

  if (!storage.exist('token')) {
    return <Redirect to="/enter" />;
  }

  return <Route {...rest} component={Component} />;
}

export default ProtectedRoute;
